import React from 'react';
import { Link } from 'react-router-dom';

function Hero() {
  const scrollToServices = (e) => {
    e.preventDefault();
    const servicesSection = document.querySelector('.services-section');
    if (servicesSection) {
      // Add offset to prevent the top of services section from being cut off
      const yOffset = -20; // 20px offset from the top
      const y = servicesSection.getBoundingClientRect().top + window.scrollY + yOffset;
      
      window.scrollTo({
        top: y,
        behavior: 'smooth'
      });
    }
  };

  return (
    <section className="hero">
      <div className="container">
        <div className="hero-content">
          <h1>
            Start a <span className="highlight">business</span>, close your <span className="highlight">books</span>, manage <span className="highlight">equity</span>, run <span className="highlight">payroll</span>, file <span className="highlight">taxes</span>, and stay <span className="highlight">compliant</span>
          </h1>
          <p>
            Whether you're a founder, startup or scaling fast, we give US companies the tools and 
            expert support to grow with confidence—without breaking the bank. 
            <br />
            <br />
            Start your free, no-obligation <span className="highlight">30-day trial</span> today.
          </p>
          <div className="hero-buttons">
            <a href="#" onClick={scrollToServices} className="hero-button">
              Get Started
            </a>
            {/* <Link to="/product-tour" className="hero-button secondary">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">
                <circle cx="12" cy="12" r="10" fill="none" stroke="currentColor" strokeWidth="2" />
                <polygon points="10,8 16,12 10,16" fill="currentColor" />
              </svg>
              Start product tour
            </Link> */}
          </div>
        </div>
      </div>
    </section>
  );
}

export default Hero;